module.exports = require("/builds/conceptik/climate-change/src/redux")